export default "__VITE_ASSET__4c914dcb__"